import {
	SheetContentType,
	useSheetStore,
} from "@/dentlab/src/store/Sheets/sheet.store";
import { JobSheetContentProps } from "../sheet-contents/job-sheet/JobSheetContent";

export const useJobSheet = () => {
	const { openSheet } = useSheetStore();

	const openJobSheet = (props: JobSheetContentProps) => {
		openSheet(SheetContentType.JOB, {
			job: props.job,
			onShareFile: props.onShareFile,
			onUnshareFile: props.onUnshareFile,
			onAcceptJobRequest: props.onAcceptJobRequest,
			onDenyJobRequest: props.onDenyJobRequest,
		});
	};

	return { openJobSheet };
};
